import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
import { formatDate } from "../../../Utils/DateAndTime";

function ProjectTaskRecurrenceForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } =  useAuthStore();

 

  const org = userData?.organization;
console.log(org)
  const fetchRecurrenceData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-task-recurrence/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;
      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_project_task_id: data.organization_project_task_id || "",
          recurrence_pattern: data.recurrence_pattern || "",
          recurrence_days: data.recurrence_days || "",
          recurrence_interval: data.recurrence_interval || "",
          start_date: formatDate(data.start_date) || "",
          end_date: formatDate(data.end_date) || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch client data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchRecurrenceData();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_project_task_id: "",
    recurrence_pattern: "",
    recurrence_days: "",
    recurrence_interval: 1,
    start_date: "",
    end_date: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_project_task_id) errors.organization_project_task_id = "Task is required";

    if (!formData.recurrence_pattern || !["Daily", "Alternate Days", "Weekly", "Monthly"].includes(formData.recurrence_pattern)) {
      errors.recurrence_pattern = "Valid recurrence pattern is required";
    }

    if (formData.recurrence_days && !["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].includes(formData.recurrence_days)) {
      errors.recurrence_days = "Invalid recurrence day selected";
    }

    if (formData.recurrence_interval && Number(formData.recurrence_interval) < 1) {
      errors.recurrence_interval = "Recurrence interval must be at least 1";
    }

    if (!formData.start_date) {
      errors.start_date = "Start date is required";
    }

    if (formData.end_date && formData.start_date && new Date(formData.end_date) < new Date(formData.start_date)) {
      errors.end_date = "End date must be after or equal to start date";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const [selectOptions, setSelectOptions] = useState({
    Tasks: []
  })

  const fetchTasks = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-tasks`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });


      const sortedTasks = [...response.data.data].sort((a, b) =>
        (a.task_title || "").localeCompare(b.task_title || "")
      );

      setSelectOptions((prev) => ({
        ...prev,
        Tasks: sortedTasks,
      }));
    } catch (e) {
      console.error("Failed to load project tasks");
    }
  };

  useEffect(() => {
    if(org?.organization_id){fetchTasks();}
 
  }, [org?.organization_id]);

  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});
// console.log("formdata",formData)
    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");

      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-task-recurrence/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task Recurrence updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-task-recurrence`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Task Recurrence added");
      }

      navigate("/project-task-recurrence");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };



  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Task Recurrences"}
        addMessage={"Task Recurrences"}
        homeLink={"/project-task-recurrence"}
        homeText={"Task Recurrences"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <Autocomplete

  fullWidth

  options={selectOptions?.Tasks || []}

getOptionLabel={(option) => option.project.project_name+" | "+ option.task_title+ " | "+option.scheduled_date    || ""}

  value={

    selectOptions?.Tasks?.find(

      (t) =>

        t.organization_project_task_id ===

        formData.organization_project_task_id

    ) || null

  }

  onChange={(event, newValue) => {

    setFormData((prev) => ({

      ...prev,

      organization_project_task_id:

        newValue?.organization_project_task_id || "",

    }));

  }}

  isOptionEqualToValue={(option, value) =>

    option.organization_project_task_id ===

    value.organization_project_task_id

  }

  renderInput={(params) => (

    <TextField

      {...params}

      label="Tasks"

      name="organization_project_task_id"

      error={!!formErrors.organization_project_task_id}

      helperText={formErrors.organization_project_task_id}

    />

  )}

/>

                <TextField
                  fullWidth
                  select
                  label="Recurrence Pattern"
                  name="recurrence_pattern"
                  value={formData.recurrence_pattern}
                  onChange={handleChange}
                  error={!!formErrors.recurrence_pattern}
                  helperText={formErrors.recurrence_pattern}
                >
                  {["Daily", "Alternate Days", "Weekly", "Monthly"].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  fullWidth
                  select
                  label="Recurrence Days"
                  name="recurrence_days"
                  value={formData.recurrence_days}
                  onChange={handleChange}
                  error={!!formErrors.recurrence_days}
                  helperText={formErrors.recurrence_days}
                >
                  {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
                    <MenuItem key={day} value={day}>
                      {day}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  fullWidth
                  type="number"
                  label="Recurrence Interval"
                  name="recurrence_interval"
                  value={formData.recurrence_interval}
                  onChange={handleChange}
                  error={!!formErrors.recurrence_interval}
                  helperText={formErrors.recurrence_interval}
                />

                <TextField
                  fullWidth
                  type="date"

                  label="Start Date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  error={!!formErrors.start_date}
                  helperText={formErrors.start_date}
                />

                <TextField
                  fullWidth
                  type="date"

                  label="End Date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  error={!!formErrors.end_date}
                  helperText={formErrors.end_date}
                />

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTaskRecurrenceForm